import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/departaments`;



export const getAll = async ({page = '', limit = '', codeLogistic = '', departament = '', town = '', status = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&codeLogistic=${codeLogistic}&departament=${departament}&town=${town}&status=${status}`, config)
 return data
}

export const create = async ({departament = {}}) => {
 const {data} = await axios.post(baseUrl, departament, config)
 return data
}

export const update = async ({departament = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, departament, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}